// extracted by mini-css-extract-plugin
export var compatible = "Compatible-module--compatible--30fa2";
export var compatibleItem = "Compatible-module--compatibleItem--2ec01";
export var link = "Compatible-module--link--80692";